import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { AgrEnvironment, EnvironmentInjector } from '@next/core-lib/environment';
import { map, Observable } from 'rxjs';

import {
  GetSalesOrderSchemasResponse,
  SalesOrderSchema,
  SalesOrderSchemaPeriodResponse,
  SalesOrderSchemaResponse,
  UpsertSalesOrderSchemaResponse,
} from '../models/sales-order-period.model';

@Injectable()
export class SalesOrderPeriodsService {
  private readonly http = inject(HttpClient);
  private readonly env = inject<AgrEnvironment>(EnvironmentInjector);
  private readonly baseUrl = `${this.env.APIM_BASE_URL}/arable-service/salesorderschema`;

  getSalesOrderSchemas(): Observable<SalesOrderSchema[]> {
    return this.http
      .get<GetSalesOrderSchemasResponse>(this.baseUrl)
      .pipe(map(({ salesOrderSchemas }) => salesOrderSchemas.map((salesOrderSchema) => this.toDomain(salesOrderSchema))));
  }

  upsertSalesOrderSchema(salesOrderSchema: SalesOrderSchema): Observable<UpsertSalesOrderSchemaResponse> {
    return this.http.post<UpsertSalesOrderSchemaResponse>(this.baseUrl, {
      salesOrderSchema,
    });
  }

  private toDomain(salesOrderSchema: SalesOrderSchemaResponse): SalesOrderSchema {
    return {
      ...salesOrderSchema,
      periods: salesOrderSchema.periods.map((period) => ({
        ...period,
        orderReceivedBefore: this.toDate(period.orderReceivedBefore),
        startDispatchFrom: this.toDate(period.startDispatchFrom),
        deliverBefore: this.toDate(period.deliverBefore),
        valutaMoment: this.toDate(period.valutaMoment),
      })),
    };
  }

  private toDate(value: SalesOrderSchemaPeriodResponse[keyof SalesOrderSchemaPeriodResponse]): Date | null {
    if (typeof value !== 'string' || value.length === 0) {
      return null;
    }

    const date = new Date(value);
    return Number.isNaN(date.getTime()) ? null : date;
  }
}
